(() => {
  const CARD_SELECTOR = '.product-card-wrapper';
  const INFO_SELECTOR = ':scope > .card > .card__content > .card__information';

  let resizeTimer;

  function visibleCards(scope = document) {
    return [...scope.querySelectorAll(CARD_SELECTOR)].filter((card) => {
      const rect = card.getBoundingClientRect();
      const style = window.getComputedStyle(card);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none';
    });
  }

  function groupByVisualRow(cards) {
    const rows = [];

    cards.forEach((card) => {
      const top = card.getBoundingClientRect().top;
      let row = rows.find((candidate) => Math.abs(candidate.top - top) <= 6);

      if (!row) {
        row = { top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function reset(cards) {
    cards.forEach((card) => {
      const info = card.querySelector(INFO_SELECTOR);
      if (info) info.style.minHeight = '';
    });
  }

  function align(scope = document) {
    const cards = visibleCards(scope);
    if (!cards.length) return;

    reset(cards);

    // Let browser calculate the natural compact heights first.
    requestAnimationFrame(() => {
      const rows = groupByVisualRow(cards);

      rows.forEach((row) => {
        if (row.cards.length < 2) return;

        let maxHeight = 0;
        const infos = [];

        row.cards.forEach((card) => {
          const info = card.querySelector(INFO_SELECTOR);
          if (!info) return;

          infos.push(info);
          maxHeight = Math.max(maxHeight, Math.ceil(info.getBoundingClientRect().height));
        });

        infos.forEach((info) => {
          info.style.minHeight = `${maxHeight}px`;
        });
      });
    });
  }

  function schedule(scope = document) {
    requestAnimationFrame(() => align(scope));
  }

  function boot() {
    schedule(document);

    // Judge.me and fonts may finish a little later.
    [250, 700, 1400, 2600].forEach((delay) => {
      window.setTimeout(() => schedule(document), delay);
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => schedule(document));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => schedule(document), 120);
  });

  document.addEventListener('shopify:section:load', (event) => {
    schedule(event.target);
    window.setTimeout(() => schedule(event.target), 500);
  });
})();
